import React, { useEffect } from 'react';
import { Element, Events, scrollSpy } from 'react-scroll';
import './index.css';
import {
  Header,
  Hero,
  Problem,
  Insight,
  HowItWorks,
  WhatYouGet,
  MidPageCTA,
  WhoItsFor,
  Pricing,
  Trust,
  FinalCTA,
} from './components';

const App = () => {
  useEffect(() => {
    Events.scrollEvent.register('begin', function () {});
    Events.scrollEvent.register('end', function () {});
    scrollSpy.update();

    return () => {
      Events.scrollEvent.remove('begin');
      Events.scrollEvent.remove('end');
    };
  }, []);

  return (
    <div className="flex flex-col overflow-x-hidden bg-white">
      <Header />

      <Element name="hero">
        <Hero />
      </Element>

      <Element name="problem">
        <Problem />
      </Element>

      <Element name="insight">
        <Insight />
      </Element>

      <Element name="how-it-works">
        <HowItWorks />
      </Element>

      <Element name="what-you-get">
        <WhatYouGet />
      </Element>

      <MidPageCTA />

      <Element name="who-its-for">
        <WhoItsFor />
      </Element>

      <Element name="pricing">
        <Pricing />
      </Element>

      <Element name="trust">
        <Trust />
      </Element>

      <Element name="final-cta">
        <FinalCTA />
      </Element>

      {/* Footer */}
      <footer className="py-8 bg-neutral-50 border-t border-neutral-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-neutral-500 text-sm">
              &copy; {new Date().getFullYear()} Turret. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              {/* Discord */}
              <a
                href="https://discord.com/invite/kY6vQRTctp"
                target="_blank"
                rel="noopener noreferrer"
                className="text-neutral-500 hover:text-[#5865F2] text-sm transition-colors flex items-center gap-2"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                </svg>
                Discord
              </a>
              {/* Documentation */}
              <a
                href="https://docs.useturret.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-neutral-500 hover:text-neutral-700 text-sm transition-colors flex items-center gap-2"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                </svg>
                Docs
              </a>
              {/* Contact the Founder (X/Twitter) */}
              <a
                href="https://x.com/evansjohnpaul"
                target="_blank"
                rel="noopener noreferrer"
                className="text-neutral-500 hover:text-neutral-900 text-sm transition-colors flex items-center gap-2"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
                Contact the Founder
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;
